/**
 * @description 数据查询 dataSearch
 * @author xiehan
 * @date 2018/11/26
 */

import Logic from '../logic-base'

const dataSearchBiz = new Logic()

dataSearchBiz.queryConditionByName = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataSearch.queryConditionByName,
    data: data
  })
}

dataSearchBiz.getHisRecord = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataSearch.getHisRecord,
    data: data
  })
}

dataSearchBiz.queryConditionById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataSearch.queryConditionById,
    data: data
  })
}

dataSearchBiz.queryData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataSearch.queryData,
    data: data
  })
}

dataSearchBiz.saveCondition = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataSearch.saveCondition,
    data: data
  })
}

dataSearchBiz.updateCondition = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataSearch.updateCondition,
    data: data
  })
}

export default dataSearchBiz
